import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Image } from "@project-stories/elements/Image/Image";
import { Button } from "@project-stories/elements/Button/Button";
import AnimatedPulse from "../../client/AnimatedPulse/AnimatedPulse";
import { useHubSpotForm } from "@src/hooks/useHubSpotForm";

export const TextMedia = ({ settings }) => {  
  const section = settings.section || {};
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  // Initialize HubSpot form for contact buttons
  const { openForm } = useHubSpotForm({
    portalId: settings.globals.hubspot.portal_id,
    formId: section?.section_hubspot_form_id ? section?.section_hubspot_form_id : settings.globals.hubspot.form_id,
    region: section?.section_hubspot_region ? section?.section_hubspot_region : settings.globals.hubspot.form_region
  });

  const handleContactClick = () => {
    openForm();
  };

  return (
    <div className="flex max-lg:flex-col justify-between items-center gap-[40px] lg:gap-[8px]">
      <div className="relative z-10 w-full lg:max-w-[480px] lg:mb-[35px]">
        <div className={`${isMobile ? settings.section.tagline_font_type_mobile : settings.section.tagline_font_type} h-[30px]`}>
          {settings.section.tagline}
        </div>
        <div className={`${isMobile ? settings.section.title_font_type_mobile : settings.section.title_font_type}`}>
          {settings.section.title}
        </div>
        <div className={`${isMobile ? settings.section.subtitle_font_type_mobile : settings.section.subtitle_font_type} my-11`}>
          {settings.section.subtitle}
        </div>
        <Button className="button button-secondary"
          text={true}
          label={settings.section.button_text}
          icon={`right-arrow-alt`}
          onClick={() => handleContactClick()}
        />
      </div>
      <div className=" w-full max-w-[652px] relative max-lg:item-center">
        <div className={`flex flex-col items-center justify-center`}
          data-section-id={settings.section.id}
        >
          <div className="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 flex items-center justify-center">
            <div className="pulse-rings absolute w-full h-full z-0 ">
              <AnimatedPulse 
                settings={{
                  size: settings.section.pulse_size,
                  borderWidth: settings.section.pulse_border_width,
                  duration: settings.section.pulse_duration,
                  maxScale: settings.section.pulse_max_scale,
                  delayOffset: settings.section.pulse_delay_offset,
                  colors: ["#e3dbc8", "#899B30", "#AC7E4C", "#D6CFF8"],
                  className: "absolute top-0 left-0 w-full h-full"
                }}
              />
            </div>
          </div>
          
        </div>
        <div className="w-full relative p-[49px] lg:pl-[96px] lg:pr-[98px] lg:pt-[159px] lg:pb-[149px]">
          <Image
            imageUrl={settings.section.image}
            alt={settings?.section?.image?.alt}
            classes={"mx-auto rounded-full aspect-square"}
          />
        </div>
      </div>
    </div>
  )
}

export default TextMedia;